/* import __COLOCATED_TEMPLATE__ from './locations.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './locations.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteLocations extends Component {}
